import * as Tgcc from '../tgccGlobal';
import * as React from 'react';
import Radium, { StyleRoot } from 'radium';
import {CSSProperties} from 'react';

type CardProps = {
    title: string;
    children?: any;
}

const wrapperStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    textTransform: 'uppercase',
    margin: '15px 10px',
    paddingTop:'20px',
    borderRadius:'15px',
    width:'100%'
};

const titleStyle: CSSProperties = {
    height: '25px',
    lineHeight: '25px',
    fontSize: '20px',
    letterSpacing: '1px',
    alignSelf: 'center',
    margin: '5px',
    fontFamily:'BarlowMedium',
    color:'#616060',
};

const contentStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: '0 auto',
    width:'100%',
    borderRadius:'15px',
    overflowX: 'hidden',
    overflowY: 'auto',
    padding:'5px',
    '@media (max-width:320px)': {
        width:'260px'
    }
};

class _CampusDashboardCard extends React.Component<CardProps, any>{
    
    render(){
        return (
            <div style={wrapperStyle}>
                <div style={titleStyle}>
                    {this.props.title}
                </div>
                <div style={contentStyle}>
                    {this.props.children}
                </div>
            </div>
        )
    }
}
export var CampusDashboardCard = Radium(_CampusDashboardCard);